import { useSelector } from 'react-redux';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import I18n from 'I18n';
import { useCallback } from 'react';
import { useChannelInstances } from 'conversations-thread-data/channel-instances/public/hooks';
import { useGenericChannels } from 'conversations-thread-data/generic-channels/public/hooks';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const filterInvalidChannelInstance = channelInstance => {
  return channelInstance.channelId !== null;
};
const filterChannelInstanceByType = filterToChannelType => channelInstance => {
  return !filterToChannelType || channelInstance.channelId === filterToChannelType;
};
const reduceToChannelInstancesByChannelTypeMap = (acc, channelInstance) => {
  const channelId = `${channelInstance.channelId}`;
  if (!acc.has(channelId)) {
    acc.set(channelId, []);
  }
  acc.get(channelId).push(channelInstance);
  return acc;
};

//Takes in a channel instance and returns an option
const getOption = channelInstance => ({
  text: channelInstance.name,
  value: channelInstance.id
});
const toOption = channelIdToLabelMap => ([channelType, channelInstancesByType]) => {
  return {
    text: channelIdToLabelMap[+channelType] || channelType,
    options: channelInstancesByType.map(getOption)
  };
};
const buildChannelIdToLabelMap = genericChannels => {
  return genericChannels.reduce((acc, currentChannel) => {
    if (currentChannel) {
      acc[currentChannel.genericChannel.id] = currentChannel.displayName;
    }
    return acc;
  }, {});
};
export const ChannelInstanceIdFilter = () => {
  const inboxId = useSelector(getCurrentInboxId);

  //Get the generic channels for the current inbox
  const {
    asyncGenericChannels
  } = useGenericChannels({
    inboxId: inboxId
  });
  const genericChannels = getData(asyncGenericChannels);
  const loadingGenericChannels = isLoading(asyncGenericChannels);

  //Get the individual channel instances for the current inbox
  const {
    asyncChannelInstances
  } = useChannelInstances({
    inboxId
  });
  const inboxChannelsResponse = getData(asyncChannelInstances);
  const loadingChannelInstances = isLoading(asyncChannelInstances);
  const {
    filterValues,
    setFilterValue
  } = useFilterValues();
  const onChange = useCallback(e => {
    const {
      value
    } = e.target;
    if (value) setFilterValue('channelInstanceId', value);else setFilterValue('channelInstanceId', null);
  }, [setFilterValue]);
  const options = inboxChannelsResponse && genericChannels ? Array.from(inboxChannelsResponse.filter(filterInvalidChannelInstance).filter(filterChannelInstanceByType(filterValues.genericChannel ? filterValues.genericChannel[0] : undefined)).reduce(reduceToChannelInstancesByChannelTypeMap, new Map())).map(toOption(buildChannelIdToLabelMap(genericChannels))) : [];
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.channelInstanceId.title"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      clearable: true,
      "data-test-id": "channel-instance-id-filter",
      isLoading: loadingChannelInstances || loadingGenericChannels,
      menuWidth: "auto",
      onChange: onChange,
      options: options,
      placeholder: /*#__PURE__*/_jsx(TruncateString, {
        children: I18n.text('conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.channelInstanceId.placeholder')
      }),
      value: filterValues.channelInstanceId
    })
  });
};
ChannelInstanceIdFilter.displayName = 'ChannelInstanceIdFilter';